import {
  Alert,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

const SubstituteCoringaDialog = ({
  open,
  players,
  availableCoringas,
  selectedPlayerIds,
  replacementPreview,
  loading,
  errorMessage,
  onTogglePlayer,
  onClose,
  onConfirm,
}) => {
  const availableCount = availableCoringas.length;
  const selectedCount = selectedPlayerIds.length;
  const hasPlayers = players.length > 0;
  const canConfirm = selectedCount > 0 && selectedCount <= availableCount;

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ fontWeight: 700 }}>Substituir jogador</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <Typography variant="body2" color="text.secondary">
            Selecione os jogadores reais que serão substituídos por coringas
            neste grupo.
          </Typography>

          <Chip
            label={`${availableCount} ${availableCount === 1 ? "coringa disponível" : "coringas disponíveis"}`}
            color={availableCount > 0 ? "primary" : "default"}
            variant="outlined"
            sx={{ alignSelf: "flex-start", fontWeight: 800 }}
          />

          {availableCount === 0 ? (
            <Alert severity="warning">
              Todos os coringas já estão sendo utilizados neste grupo.
            </Alert>
          ) : null}

          {errorMessage ? <Alert severity="error">{errorMessage}</Alert> : null}

          <Paper
            elevation={0}
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1.5,
              p: 1,
            }}
          >
            <Stack spacing={0.4}>
              {!hasPlayers ? (
                <Typography variant="body2" color="text.secondary">
                  Nenhum jogador real disponível para substituição.
                </Typography>
              ) : (
                players.map((player) => {
                  const checked = selectedPlayerIds.includes(player.id);
                  const disabled =
                    loading ||
                    availableCount === 0 ||
                    (!checked && selectedCount >= availableCount);

                  return (
                    <FormControlLabel
                      key={player.id}
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={() => onTogglePlayer(player.id)}
                          disabled={disabled}
                        />
                      }
                      label={player.name}
                      sx={{
                        mx: 0,
                        px: 1,
                        borderRadius: 1,
                        "&:hover": { bgcolor: "action.hover" },
                      }}
                    />
                  );
                })
              )}
            </Stack>
          </Paper>

          {replacementPreview.length > 0 ? (
            <Box>
              <Typography sx={{ fontWeight: 800, mb: 0.8 }}>
                Substituições
              </Typography>
              <Stack spacing={0.6}>
                {replacementPreview.map((item) => (
                  <Paper
                    key={item.playerId}
                    elevation={0}
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 1,
                      px: 1,
                      py: 0.75,
                    }}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                      {item.playerName} → {item.coringaName}
                    </Typography>
                  </Paper>
                ))}
              </Stack>
            </Box>
          ) : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Voltar
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={loading || !canConfirm}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {loading ? "Substituindo..." : "Confirmar substituições"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubstituteCoringaDialog;
